export default "__VITE_ASSET__KYch1hw3__"